<div class="produtos-commerce">
    <app-header
        [hasBackButton]="!isList"
        [hasButtons]="true"
        [hasSearchButton]="isList"
        [hasMinCharacters]="false"
        [searchInput]="searchTerm"
        [searchPlaceholder]="isList ? ('support.manage-integrations.header.search-placeholder' | translate) : null"
        [title]="(('support.manage-integrations.header.titles.' + (isList ? 'list' : selectedIntegrationToEdit == null ? 'new' : 'edition')) | translate: { name: selectedIntegrationToEdit?.holdingName})"
        (onSearch)="searchTerm = $event"
        (onGoBack)="goBackToList()">

        @if (isList) {
            <button customButton styleType="primary" iconName="plus" [label]="'support.manage-integrations.header.titles.new' | translate" [isLoading]="false" (click)="openNewIntegration()"></button>
        }
    </app-header>

    <div class="corpo-pagina">
        @if (isList) {
            <div class="card card-default">
                <app-support-gridview [config]="config" (onEdit)="openIntegrationEdition($event)" [paginated]="true" [pageSize]="pageSize" [pageIndex]="actualPage" [totalItems]="totalIntegrations" [hidePageSize]="true" [showFirstLastButtons]="true" (onPageChange)="changePage($event)"></app-support-gridview>
            </div>
        } @else {
            <app-integration-manage #templateIntegrationManageComponent [integration]="selectedIntegrationToEdit" (goBackToList)="goBackToList()" (saveIntegration)="handleIntegrationSave($event)" (onIntegrationUpdate)="handleIntegrationUpdate($event)"></app-integration-manage>
        }
        </div>
</div>
<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
